module.exports = __webpack_public_path__ + "img/ec-council.4dfddcc6.png";